var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('LandMap',{attrs:{"landList":_vm.landList,"trajectoryList":_vm.trajectoryList,"mapTopInfoOptions":_vm.mapTopInfoOptions,"mapRightInfoOptions":_vm.mapRightInfoOptions},scopedSlots:_vm._u([{key:"landInfo",fn:function(ref){
var landInfo = ref.landInfo;
return [_c('MapLandInfoHorizontal',{attrs:{"curLandInfo":landInfo}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }